<script>
import SocialVisitsService from '@/services/SocialVisitsService';

export default {
  name: 'RejectRequestModal',
  props: {
    visit: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      reason: '',
      rejectionReasons: [
        'Needs to be rescheduled by establishment',
        'Resident or Visitor wants to reschedule',
        'Admin error',
        'Resident can’t make it',
        'Operational reasons',
        'Resident doesn’t want this visit',
        'Resident has left the establishment',
        'Not accepted in time',
        'Not approved to contact',
        'Change of Visitor(s)',
      ],
      showSelect: false,
    };
  },
  methods: {
    async rejectVisit() {
      try {
        this.loading = true;
        await SocialVisitsService.rejectRequest(this.visit._id, {
          cancellation_reason: this.reason,
        });
        this.$toast.success('Request rejected', {
          toastClassName: ['toast-std', 'success-toast'],
        });
        this.refresh();
      } catch (e) {
        console.error('Error rejecting visit: ', e);
        const errorMessage = 'An error occurred while trying to reject this request'
        this.$toast.error(errorMessage, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit('close');
    },
    refresh() {
      this.$emit('refresh');
    },
  },
}
</script>

<template>
  <b-col class="p-0">
    <h3 class="mb-2 text-center">Reject Visit for</h3>
    <h4 class="mb-2 text-center">{{ visit.prisoner.firstname }} {{ visit.prisoner.lastname }} ({{ visit.prisoner.prisoner_number }})</h4>
    <div v-if="!showSelect">
      <label>
        Enter a reason for rejecting the request
      </label>
      <b-form-textarea v-model="reason" class="mb-1" maxlength="100" />
    </div>
    <div v-else>
      <label>
        Select a reason for rejecting the request
      </label>
      <select
        v-model="reason"
        class="form-control mb-2"
      >
        <option
          v-for="(reasonText, index) in rejectionReasons"
          :key="index"
          :value="reason"
        >
          {{ reasonText }}
        </option>
      </select>
    </div>
    <div class="d-flex justify-content-end mb-1">
      <b-button class="mr-1" :disabled="loading" @click="close()">Close</b-button>
      <b-button variant="danger" :disabled="loading || !reason" @click="rejectVisit">Reject</b-button>
    </div>
  </b-col>
</template>
